/**
 * @ Author: Housefolios
 * @ Create Time: 2021-10-05 11:07:32
 * @ Modified by: David Helmick
 * @ Modified time: 2025-06-17 19:15:28
 * @ Description: Main component of the create account page
 */

import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { useQuery, useMutation } from '@apollo/client/react'
// Centralized lodash imports - much cleaner!
import {
  map,
  replace,
  split,
  upperFirst,
  toLower,
  filter,
  isEmpty,
  head,
  get,
  capitalize,
  includes,
} from '@/utils/lodash'

import {
  Button,
  ButtonGroup,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  List,
  ListItem,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Backdrop,
  CircularProgress,
  Box,
  useMediaQuery,
} from '@mui/material'

import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { CREATE_SESSION } from '@/housefolios-components/LaunchpadComponents/mutations'

import {
  ValidatorForm,
  TextValidator,
} from '@/housefolios-components/shared/muiFormValidator'

import moneyBackGuarantee from '@/assets/images/moneyBackGuarantee.png'
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk'
import ImageIcon from '@mui/icons-material/Image'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'

import createAccountLogo from '@/assets/images/HousefoliosCloudTransparent.png'
import { GET_PARTNER, GET_SUBSCRIPTION_PLAN } from './queries'
import SubscriptionPlanPrice from './SubscriptionPlanPrice'
import PaymentForm from '../PaymentForm'
import { CHECK_SIGN_UP, GET_COUPON, SIGN_UP } from './mutations'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { enqueueSnackbar } from 'notistack'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Check } from '@mui/icons-material'
import { SUBSCRIBE } from '@/housefolios-components/Session/mutations'
import { GET_ME } from '@/housefolios-components/Session/queries'
import useAffiliate from '@/hooks/useAffiliate'
import {
  useNavigate,
  useParams,
  Link as RouterLink,
} from 'react-router'
import NameInput from '../../FormComponents/NameInput'
import PhoneInput from '../../FormComponents/PhoneInput'
import EmailInput from '../../FormComponents/EmailInput'
import PasswordInput from '../../FormComponents/PasswordInput'
import { useUrlParams } from '@/hooks/useUrlParams'
import { useSignupMutation } from '@/hooks/useSignupMutation'
import FormSection from '../Shared/FormSection'
import AccountForm from './AccountForm'
import PlanSelection from './PlanSelection'
import PaymentSection from './PaymentSection'
import {
  AuthMobileLogo,
  authLogo50Sx,
  authLogoCenterSx,
} from '../../SignIn/authChrome'

function CreateAccountCardComponent(props) {
  const { planName } = useParams()
  // const [searchStatus1, setSearchStatus1] = useState(false);
  // const toggleSearch1 = () => setSearchStatus1(!searchStatus1);

  const [selectedPlan, setSelectedPlan] = useState(planName)
  const [tab, setTab] = useState(0)
  const hiddenSmDown = useMediaQuery((theme) =>
    theme.breakpoints.down('sm'),
  )

  let navigate = useNavigate()

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  let urlFirstName = urlParams.get('firstName') || ''
  let urlEmail = urlParams.get('email') || ''
  let hfpid = urlParams.get('hfpid')
  let refOrg = urlParams.get('org')
  let source = urlParams.get('source')
  let priceLimit = urlParams.get('limit')
  let headerImage = createAccountLogo
  let allowedPlans = []
  let applyCoupon = ''
  let applyPercent = null
  let applyCouponAmount = null
  let disablePromoCode = false
  let memberTrial = 0
  let trialInvoiceAmount = 0

  const isCoached = includes(selectedPlan, 'coaching')

  const [paymentIntervals, setPaymentIntervals] = useState(
    parseInt(urlParams.get('payments')) || 1,
  )

  if (isCoached) {
    disablePromoCode = true
  }
  if (includes(selectedPlan, 'group-coaching') && !applyCoupon) {
    if (paymentIntervals == 1) {
      applyCoupon = 'GTzjUUmX'
    } else if (paymentIntervals == 2) {
      applyCoupon = 'CxxvDO0k'
    } else if (paymentIntervals == 3) {
      applyCoupon = 'arM9K3su'
    }
  }

  //OVERVIEW COMMENT: This is a setup of Affiliate information
  let result = useQuery(GET_PARTNER, {
    variables: { name: source },
  })
  const partnerLoading = result.loading
  const { partner = {} } = result.data || {}

  //// let rockstarReferrer = ["https://go.housefolios.com/rerockstars"]
  //// let myndReferrer = ["https://housefolios.com/mynd/", "https://www.housefolios.com/mynd/"]
  ////if (source === "rerockstars" && (includes(rockstarReferrer, document.referrer) || includes(map(rockstarReferrer, ref => ref+'/'), document.referrer)) && selectedPlan === 'investor-yearly')
  // if (source === "rerockstars" && selectedPlan === 'investor-yearly')
  // {
  //     applyCoupon = 'OXpyi0Nc'
  //     applyCouponAmount = 17700
  //     disablePromoCode = true
  // }
  // ////if (source === "mynd" && (includes(myndReferrer, document.referrer) || includes(map(myndReferrer, ref => ref+'/'), document.referrer)))
  // if (source === "mynd")
  // {
  //     applyCoupon = '9a309m9M'
  //     applyPercent = 50
  //     disablePromoCode = true
  // }

  ////let paulReferrer = ["https://housefolios.com/paul", "https://www.housefolios.com/paul"]
  ////if (source === "paulmccomas" && (includes(paulReferrer, document.referrer) || includes(map(paulReferrer, ref => ref+'/'), document.referrer)))

  //OVERVIEW COMMENT: This is a setup of Member information
  const [{ affiliate, affiliateLoading, urlAffiliate }] =
    useAffiliate({
      memberValue: source,
    })

  if (!affiliateLoading && !partnerLoading) {
    if (isEmpty(affiliate) && isEmpty(partner)) {
      if (!isCoached) {
        source = null
        memberTrial = 7
        trialInvoiceAmount = 1
      }
    } else {
      let { createAccount = {} } = isEmpty(affiliate)
        ? partner
        : affiliate
      if (!createAccount) createAccount = {}
      hfpid = affiliate ? affiliate.hfpid : ''
      headerImage =
        get(createAccount, 'headerImage.0.url') || createAccountLogo
      applyCoupon = createAccount.applyCoupon || ''
      applyPercent = createAccount.applyPercent || null
      applyCouponAmount = createAccount.applyCouponAmount || null
      if (!isCoached) {
        memberTrial = createAccount.memberTrial || 0
        trialInvoiceAmount = createAccount.trialInvoiceAmount || 0
        disablePromoCode = createAccount.disablePromoCode || false
      }
      allowedPlans = createAccount.plans || []
    }
  }

  useEffect(() => {
    if (includes(selectedPlan, 'group-coaching')) {
      if (paymentIntervals == 1) {
        applyCoupon = 'GTzjUUmX'
      } else if (paymentIntervals == 2) {
        applyCoupon = 'CxxvDO0k'
      } else if (paymentIntervals == 3) {
        applyCoupon = 'arM9K3su'
      }
      setCoupon(applyCoupon)
      checkCoupon(applyCoupon)
    } else {
      setCoupon('')
      checkCoupon('')
    }
  }, [selectedPlan])

  useEffect(() => {
    if (isCoached) {
      disablePromoCode = true
    }

    if (!affiliateLoading && !partnerLoading) {
      if (isEmpty(affiliate) && isEmpty(partner)) {
        if (!isCoached) {
          source = null
          memberTrial = 7
          trialInvoiceAmount = 1
        }
      } else {
        let { createAccount = {} } = isEmpty(affiliate)
          ? partner
          : affiliate
        if (!createAccount) createAccount = {}
        hfpid = affiliate ? affiliate.hfpid : ''
        headerImage =
          get(createAccount, 'headerImage.0.url') || createAccountLogo
        applyCoupon = createAccount.applyCoupon || ''
        applyPercent = createAccount.applyPercent || null
        applyCouponAmount = createAccount.applyCouponAmount || null
        if (!isCoached) {
          memberTrial = createAccount.memberTrial || 0
          trialInvoiceAmount = createAccount.trialInvoiceAmount || 0
          disablePromoCode = createAccount.disablePromoCode || false
        }
        allowedPlans = createAccount.plans || []
      }
    }
  }, [isCoached])

  useEffect(() => {
    if (includes(selectedPlan, 'group-coaching')) {
      if (paymentIntervals == 1) {
        applyCoupon = 'GTzjUUmX'
      } else if (paymentIntervals == 2) {
        applyCoupon = 'CxxvDO0k'
      } else if (paymentIntervals == 3) {
        applyCoupon = 'arM9K3su'
      }
      setCoupon(applyCoupon)
      checkCoupon(applyCoupon)
    }
  }, [paymentIntervals])

  const [token, setToken] = useState('')
  //const [element, setElement] = useState(null)
  const [resetToken, setResetToken] = useState(() => {
    return null
  })
  const [coupon, setCoupon] = useState(applyCoupon)
  const [couponValid, setCouponValid] = useState(
    applyCoupon ? true : false,
  )
  const [couponPercent, setCouponPercent] = useState(applyPercent)
  const [couponAmount, setCouponAmount] = useState(applyCouponAmount)

  const [email, setEmail] = useState(urlEmail)
  const [firstName, setFirstName] = useState(urlFirstName)
  const [lastName, setLastName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [password, setPassword] = useState('')
  const [passwordMask, setPasswordMask] = useState(true)

  const [activeTab, setActiveTab] = useState('Annual')

  const tabSwitch = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const [openBillingInfo, setOpenBillingInfo] = useState(false)
  const handleOpenBillingInfo = () => {
    setOpenBillingInfo(true)
  }
  const handleCloseBillingInfo = () => {
    setOpenBillingInfo(false)
  }

  const currencyFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const [createBillingPortalSession] = useMutation(CREATE_SESSION)

  const changePlan = async () => {
    var session = await createBillingPortalSession()

    window.open(
      session.data.createBillingPortalSession.url,
      '_self',
      '',
    )
  }

  //  useEffect(() => {
  //    if (!affiliateLoading && !partnerLoading) {
  //      setCoupon(applyCoupon)
  //      setCouponValid(applyCoupon ? true : false)
  //      setCouponPercent(applyPercent)
  //      setCouponAmount(applyCouponAmount)
  //      if (selectedPlan && !isEmpty(allowedPlans) && !includes(allowedPlans, selectedPlan)) {
  //        setSelectedPlan(head(allowedPlans))
  //      }
  //    }
  //  }, [affiliateLoading, partnerLoading, selectedPlan])

  const [getCoupon] = useMutation(GET_COUPON)

  //  const pricingPlans = [
  //    {
  //      nameMonthly: 'investor-monthly',
  //      nameYearly: 'investor-yearly',
  //      label: 'Investor',
  //      subHeaderMonthly: 'Monthly Plan',
  //      subHeaderYearly: 'Annual Plan',
  //    },
  //    {
  //      nameMonthly: 'growth-monthly',
  //      nameYearly: 'growth-yearly',
  //      label: 'Growth',
  //      subHeaderMonthly: 'Monthly Plan',
  //      subHeaderYearly: 'Annual Plan',
  //    },
  //    {
  //      nameMonthly: 'pro-monthly',
  //      nameYearly: 'pro-yearly',
  //      label: 'Pro',
  //      subHeaderMonthly: 'Monthly Plan',
  //      subHeaderYearly: 'Annual Plan',
  //    },
  //  ]

  const createToken = async (stripe, cardElement, nameOnCard) => {
    if (!nameOnCard) setToken('')
    else {
      await stripe
        // .createToken({
        //   type: 'card',
        //   card: cardElement,
        //   name: nameOnCard,
        // })
        .createToken(cardElement, {
          name: nameOnCard,
        })
        .then((res) => {
          var errorElement = document.getElementById('card-errors')
          if (res.error) {
            setToken('')
            if (errorElement)
              errorElement.textContent = res.error.message
          } else {
            setToken(res.token)
            if (errorElement) errorElement.textContent = null
          }
        })
    }
  }

  const checkCoupon = async (coupon) => {
    if (!coupon) setCouponValid(null)
    else
      await getCoupon({
        variables: {
          code: coupon,
        },
      })
        .then(async ({ data  }) => {
          if (
            !data.getCoupon.maxRedemptions ||
            data.getCoupon.maxRedemptions >
              data.getCoupon.timesRedeemed
          ) {
            setCouponValid(true)
            setCouponPercent(data.getCoupon.percentOff)
            setCouponAmount(data.getCoupon.amountOff)
          } else {
            enqueueSnackbar(`Promo Code not valid`, {
              variant: 'error',
              autoHideDuration: 3000,
            })
            setCouponValid(false)
          }
        })
        .catch(async ({ error  }) => {
          enqueueSnackbar(`Promo Code not valid`, {
            variant: 'error',
            autoHideDuration: 3000,
          })
          setCouponValid(false)
          setCouponPercent(null)
          setCouponAmount(null)
          setCoupon('')
        })
  }

  const toggle = (tab) => {
    setSelectedPlan(tab)
  }

  useEffect(() => {
    if (urlParams.get('coupon')) {
      setCoupon(urlParams.get('coupon'))
      checkCoupon(urlParams.get('coupon'))
    } else if (coupon) {
      checkCoupon(coupon)
    }
  }, [])

  const [agree, setAgree] = useState(false)

  const [loader, setLoader] = useState(false)

  const {
    hfpid: urlHfpid,
    refOrg: urlRefOrg,
    planID,
  } = useUrlParams()

  const userInput = {
    profile: {
      firstname: firstName,
      lastname: lastName,
    },
    email: email.toLowerCase(),
    organization: firstName + lastName,
    phone: phoneNumber,
    stripePlanId: planID,
    password: password,
    referredByDetails: urlHfpid
      ? {
          affiliateId: urlHfpid,
          saleDate: new Date(),
          productSelected: 'free',
          productTotalPrice: 0,
          couponUsed: null,
          active: true,
        }
      : null,
    refOrg: urlRefOrg || null,
  }

  const { checkSignup, signUp, signUpError } =
    useSignupMutation(userInput)

  const handleSubmit = async () => {
    setLoader(true)
    const productChoice = 'free'
    const planPrice = 0
    try {
      if (coupon && !couponValid) {
        await getCoupon({
          variables: {
            code: coupon,
          },
        })
          .then(async ({ data  }) => {
            if (
              !data.getCoupon.maxRedemptions ||
              data.getCoupon.maxRedemptions >
                data.getCoupon.timesRedeemed
            ) {
              setCouponValid(true)
              setCouponPercent(data.getCoupon.percentOff)
              setCouponAmount(data.getCoupon.amountOff)
            } else {
              enqueueSnackbar(`Promo Code not valid`, {
                variant: 'error',
                autoHideDuration: 3000,
              })
              setCouponValid(false)
            }
          })
          .catch(async ({ error  }) => {
            enqueueSnackbar(`Promo Code not valid`, {
              variant: 'error',
              autoHideDuration: 3000,
            })
            setCouponValid(false)
            setCoupon('')
            setCouponPercent(null)
            setCouponAmount(null)
          })
      }

      await checkSignup()
      const { data } = await signUp().finally(() => {
        setLoader(false)
      })

      localStorage.setItem('token', data.signUp.token)
      localStorage.setItem(`buyBox-${data.signUp.orgId}`, 'true')

      setAgree(false)
      setTab(selectedPlan ? 2 : 1)
      // window.location.reload()
    } catch (error) {
      console.log('"' + error.message + '"')
      var errorElement = document.getElementById('card-errors')
      if (error && errorElement) {
        errorElement.textContent =
          error.message.slice(0, 21) === 'GraphQL error: Error:'
            ? error.message.slice(21)
            : null
      }
    } finally {
      setLoader(false)
    }
  }

  const [subscribe] = useMutation(SUBSCRIBE)

  const hanldeSubmitSubscription = async () => {
    setLoader(true)
    subscribe({
      variables: {
        userInput: {
          email: toLower(email),
          stripeToken: token,
          stripePlanId: subscriptionPlan.planId,
          coupon,
          sendEmail: true,
          stripeEntryPlanId: entryPlanId,
          paymentIntervals: isCoached ? paymentIntervals : 0,
        },
      },
      refetchQueries: [
        {
          query: GET_ME,
        },
      ],
    })
      .catch((error) => {
        var errorElement = document.getElementById('card-errors')

        if (error && errorElement) {
          errorElement.textContent =
            error.message.slice(0, 21) === 'GraphQL error: Error:'
              ? error.message.slice(21)
              : null
        }
      })
      .finally(() => {
        const productChoice = toLower(
          plan[0] + 'Plan - ' + plan[1],
        ).includes('starter')
          ? 'starter'
          : toLower(plan[0] + 'Plan - ' + plan[1]).includes(
                'investor',
              )
            ? 'investor'
            : toLower(plan[0] + 'Plan - ' + plan[1]).includes(
                  'growth',
                )
              ? 'growth'
              : toLower(plan[0] + 'Plan - ' + plan[1]).includes('pro')
                ? 'pro'
                : toLower(plan[0] + 'Plan - ' + plan[1]).includes(
                      'enterprise',
                    )
                  ? 'enterprise'
                  : ''
        setLoader(false)
      })
  }

  const planOptionConfigs = [
    {
      name: 'investor-monthly',
      label: 'Investor plan - Monthly',
      yearlyPrice: false,
    },
    {
      name: 'growth-monthly',
      label: 'Growth plan - Monthly',
      yearlyPrice: false,
    },
    {
      name: 'pro-monthly',
      label: 'Pro plan - Monthly',
      yearlyPrice: false,
    },
    {
      name: 'investor-yearly',
      label: 'Investor plan - Yearly',
      yearlyPrice: true,
    },
    {
      name: 'growth-yearly',
      label: 'Growth plan - Yearly',
      yearlyPrice: true,
    },
    {
      name: 'pro-yearly',
      label: 'Pro plan - Yearly',
      yearlyPrice: true,
    },
    {
      name: 'group-coaching',
      label: 'Group Coaching - Monthly',
      yearlyPrice: false,
    },
    {
      name: 'personalized-coaching',
      label: 'Personalized Coaching plan',
      yearlyPrice: false,
    },
  ]

  let planOptions = map(planOptionConfigs, (config) => ({
    title: (
      <SubscriptionPlanPrice
        subscriptionPlanId={config.name}
        planLabel={config.label}
        yearlyPrice={config.yearlyPrice}
        currencyFormat={currencyFormat}
      />
    ),
    textAlign: 'left',
    name: config.name,
  }))

  const { loading, data, error } = useQuery(GET_SUBSCRIPTION_PLAN, {
    variables: { subscriptionPlan: selectedPlan },
    errorPolicy: 'ignore',
  })

  const { subscriptionPlan = {} } = data || {}

  let entryPlanId = ''
  let entrySubscriptionPlan = {}
  const entryPlanResults = useQuery(GET_SUBSCRIPTION_PLAN, {
    variables: {
      subscriptionPlan:
        `${selectedPlan}-entry-fee` +
        (paymentIntervals > 1 ? `-${paymentIntervals}-payments` : ''),
    },
    errorPolicy: 'ignore',
  })
  if (isCoached) {
    const entryData = (entryPlanResults || {}).data || {}
    entrySubscriptionPlan = entryData.subscriptionPlan || {}
    entryPlanId = entrySubscriptionPlan.planId
  }

  if (loading || (entryPlanResults || {}).loading) return 'loading'
  if (!subscriptionPlan) {
    setSelectedPlan(head(planOptions).name)
    return 'Invalid Plan'
  }
  const plan = split(subscriptionPlan.subscriptionPlan, '-')
  let trialEnd = new Date()
  trialEnd.setDate(
    trialEnd.getDate() + subscriptionPlan.trialPeriodDays,
  )

  const referredByDetails = {
    affiliateId: hfpid,
    saleDate: new Date(),
    productSelected: subscriptionPlan.subscriptionPlan,
    productTotalPrice: subscriptionPlan.price,
    couponUsed: coupon,
    active: true,
  }

  const tabSwitch2 = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const pricingPlans = [
    //   {
    //     nameMonthly: 'free-monthly',
    //     nameYearly: 'free-yearly',
    //     label: 'Free',
    //     subHeaderMonthly: '',
    //     subHeaderYearly: '',
    //     search: '*Nationwide property search',
    //     analyze: '*Analyze off-market properties',
    //     comp: '*Sold comp data'
    //  },
    //  {
    //    nameMonthly: 'investor-monthly',
    //    nameYearly: 'investor-yearly',
    //     label: 'Investor',
    //     subHeaderMonthly: 'Monthly Plan',
    //     subHeaderYearly: 'Annual Plan',
    //     search: 'Nationwide property search',
    //     analyze: 'Analyze off-market properties',
    //     comp: 'Sold comp data'
    //  },
    //  {
    //    nameMonthly: 'growth-monthly',
    //    nameYearly: 'growth-yearly',
    //     label: 'Growth',
    //     subHeaderMonthly: 'Monthly Plan',
    //     subHeaderYearly: 'Annual Plan',
    //     search: 'Nationwide property search',
    //     analyze: 'Analyze off-market properties',
    //     comp: 'Sold comp data',
    //     //housefoliosMarketplace: 'List on Housefolios marketplace',
    //   },
    //   {
    //     nameMonthly: 'pro-monthly',
    //     nameYearly: 'pro-yearly',
    //     label: 'Pro',
    //     subHeaderMonthly: 'Monthly Plan',
    //     subHeaderYearly: 'Annual Plan',
    //     search: 'Nationwide property search',
    //     analyze: 'Analyze off-market properties',
    //     comp: 'Sold comp data',
    //     //housefoliosMarketplace: 'List on Housefolios marketplace',
    //   },
    // ] : [
    {
      nameMonthly: 'growth-monthly',
      nameYearly: 'growth-yearly',
      label: 'Growth',
      subHeaderMonthly: 'Monthly Plan',
      subHeaderYearly: 'Annual Plan',
      search: 'Nationwide property search',
      analyze: 'Analyze off-market properties',
      comp: 'Sold comp data',
      //housefoliosMarketplace: 'List on Housefolios marketplace',
    },
    {
      nameMonthly: 'pro-monthly',
      nameYearly: 'pro-yearly',
      label: 'Pro',
      subHeaderMonthly: 'Monthly Plan',
      subHeaderYearly: 'Annual Plan',
      search: 'Nationwide property search',
      analyze: 'Analyze off-market properties',
      comp: 'Sold comp data',
      prioritized: 'Prioritized Customer Service',
      access: 'Access to Pro-Level Resources',
      exclusive: 'Exclusive Training Calls',
      listVerified: 'List Verified Properties on Our Marketplace',
      earlyAccess: 'Early Access to Investor Property Listings',
      //housefoliosMarketplace: 'List on Housefolios marketplace',
    },
    {
      nameMonthly: 'investor-monthly',
      nameYearly: 'investor-yearly',
      label: 'Investor',
      subHeaderMonthly: 'Monthly Plan',
      subHeaderYearly: 'Annual Plan',
      search: 'Nationwide property search',
      analyze: 'Analyze off-market properties',
      comp: 'Sold comp data',
    },
    {
      nameMonthly: 'group-coaching',
      nameYearly: 'group-coaching',
      label: 'Group Coaching',
      subHeaderMonthly: 'Plan',
      subHeaderYearly: 'Plan',
      search: 'Nationwide property search',
      analyze: 'Analyze off-market properties',
      comp: 'Sold comp data',
      prioritized: 'Prioritized Customer Service',
      access: 'Access to Pro-Level Resources',
      exclusive: 'Exclusive Training Calls',
      listVerified: 'List Verified Properties on Our Marketplace',
      earlyAccess: 'Early Access to Investor Property Listings',
      groupCoaching: 'Weekly Group Coaching',
      //housefoliosMarketplace: 'List on Housefolios marketplace',
    },
    {
      nameMonthly: 'personalized-coaching',
      nameYearly: 'personalized-coaching',
      label: 'Personalized Coaching',
      subHeaderMonthly: 'Plan',
      subHeaderYearly: 'Plan',
      search: 'Nationwide property search',
      analyze: 'Analyze off-market properties',
      comp: 'Sold comp data',
      prioritized: 'Prioritized Customer Service',
      access: 'Access to Pro-Level Resources',
      exclusive: 'Exclusive Training Calls',
      listVerified: 'List Verified Properties on Our Marketplace',
      earlyAccess: 'Early Access to Investor Property Listings',
      groupCoaching: 'Weekly Group Coaching',
      personalizedCoaching: 'Monthly One on One Coaching',
      //housefoliosMarketplace: 'List on Housefolios marketplace',
    },
  ]

  if (affiliateLoading)
    return (
      <Backdrop open={true} style={{ color: '#fff', zIndex: 2000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    )

  return (
    <>
      <AuthMobileLogo src={headerImage} />
      {hiddenSmDown || tab === 0 ? null : (
        <Grid sx={authLogoCenterSx}>
          <Box
            component="img"
            src={headerImage}
            alt="Housefolios"
            sx={authLogo50Sx}
          />
        </Grid>
      )}
      <Grid
        container
        direction="column"
        spacing={2}
        justify-content="center"
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid size={12}>
          <ValidatorForm onSubmit={handleSubmit}>
            <BlockUi
              blocking={loader}
              loader={
                <PacmanLoader
                  color={'var(--primary)'}
                  loading={loader}
                />
              }
              message={
                <Box sx={{ color: '#368cff' }}>Creating Account</Box>
              }
            >
              {tab === 0 && (
                <AccountForm
                  headerImage={headerImage}
                  email={email}
                  setEmail={setEmail}
                  password={password}
                  setPassword={setPassword}
                  passwordMask={passwordMask}
                  setPasswordMask={setPasswordMask}
                  firstName={firstName}
                  setFirstName={setFirstName}
                  lastName={lastName}
                  setLastName={setLastName}
                  phoneNumber={phoneNumber}
                  setPhoneNumber={setPhoneNumber}
                  signUpError={signUpError}
                  agree={agree}
                  setAgree={setAgree}
                />
              )}

              {tab === 1 && (
                <PlanSelection
                  setSelectedPlan={setSelectedPlan}
                  setPaymentIntervals={setPaymentIntervals}
                  currencyFormat={currencyFormat}
                  memberTrial={memberTrial}
                  activeTab={activeTab}
                  tabSwitch2={tabSwitch2}
                  setTab={setTab}
                  allowedPlans={allowedPlans}
                  pricingPlans={pricingPlans}
                  trialInvoiceAmount={trialInvoiceAmount}
                  source={source}
                />
              )}

              {tab === 2 && (
                <PaymentSection
                  coupon={coupon}
                  setCoupon={setCoupon}
                  couponValid={couponValid}
                  couponPercent={couponPercent}
                  couponAmount={couponAmount}
                  checkCoupon={checkCoupon}
                  plan={plan}
                  token={token}
                  createToken={createToken}
                  setResetToken={setResetToken}
                  subscriptionPlan={subscriptionPlan}
                  disablePromoCode={disablePromoCode}
                  agree={agree}
                  handleSubmit={hanldeSubmitSubscription}
                  memberTrial={memberTrial}
                  trialInvoiceAmount={trialInvoiceAmount}
                  isCoached={isCoached}
                  entrySubscriptionPlan={entrySubscriptionPlan}
                  paymentIntervals={paymentIntervals}
                  setPaymentIntervals={setPaymentIntervals}
                  setTab={setTab}
                />
              )}

            </BlockUi>
          </ValidatorForm>
        </Grid>
      </Grid>
    </>
  )
}

export default CreateAccountCardComponent
